const COOKIES = {
    ACCOUNT: {
        AUTHENTICATE_TOKEN: 'auth-token',
        REFRESH_TOKEN: 'auth-refresh-token',
    },
};

export default COOKIES;
